import { createSelector } from 'reselect';
import orderBy from 'lodash/orderBy';

import messages from 'Workspace/Publications/components/PublicationList/messages';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { decodeHTMLEntity } from 'Workspace/Publications/utils';
import { publishFormat } from 'Workspace/Publications/utils/constants';

const selectPublicationsList = (state) => (state.getIn(['workspacePublications', 'publications']));
const selectPublicationsSort = (state) => (state.getIn(['workspacePublications', 'publicationsSort']));
const selectPublicationsSearch = (state) => (state.getIn(['workspacePublications', 'publicationsSearch']));

function orderByType(data = '', type) {
  switch (type) {
    case 'date':
      return Date.parse(data);
    default:
      return data.toLowerCase();
  }
}

const getAuthorName = (outputType, authorName) => {
  if (authorName) {
    return decodeHTMLEntity(authorName);
  }
  if (outputType === publishFormat.CLASS_ON_DEMAND && !authorName) {
    return intl.formatMessage(messages.PEARSON);
  }
  return intl.formatMessage(messages.unknown);
};

const getTrimmerPublicationList = (publicationList) => publicationList?.map((item) => ({
  ...item,
  title: item.title?.trim(),
  author: getAuthorName(item.outputType, item.author)?.trim(),
}));

const getSortedPublicationList = createSelector(
  [selectPublicationsList, selectPublicationsSort],
  (publicationList, sort) => {
    const trimmedPublicationList = getTrimmerPublicationList(publicationList);
    if (sort.key) {
      return orderBy(
        trimmedPublicationList,
        [(publicationItem) => orderByType(publicationItem[sort.key], sort.type)],
        sort.order
      );
    }
    return trimmedPublicationList;
  });

const getFilteredPublicationList = createSelector(
  [getSortedPublicationList, selectPublicationsSearch],
  (sortedPublicationList, search) => search ?
    sortedPublicationList.filter((publicationItem) => publicationItem?.title?.toLowerCase().includes(search?.toLowerCase())) :
    sortedPublicationList
);

export {
  selectPublicationsList,
  selectPublicationsSort,
  selectPublicationsSearch,
  getFilteredPublicationList,
  getSortedPublicationList,
};
